import { FWS_BASE_URL } from "@fwa/src/services/apiClient";

export const fwsUrlFundraisingPageType = ({
  nameOrUniqueId,
}: {
  nameOrUniqueId: string;
}): string => `${FWS_BASE_URL}/fundraisingpagetypes/${nameOrUniqueId}`;

export default fwsUrlFundraisingPageType;
